export default "__VITE_ASSET__c07efdad__"